import { PolicyData } from 'pages/configuration/policy/PolicyData'
import React from 'react'
import Policy from './Policy'
import PolicyHeader from './PolicyHeader';
import { Typography } from '@mui/material';

function TermsAndCondition() {
  const searchParams = new URLSearchParams(window.location.search);
  const type = searchParams.get('type');
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {(type && isMobileParams) ?
        <div>
          <Policy policyData={PolicyData} />
        </div>
        : 
        <div>
        <PolicyHeader />
        <Typography className='policyHeadingAlign'>Terms and Conditions</Typography>
        <Policy policyData={PolicyData} />
      </div>}
    </div>
  )
}

export default TermsAndCondition
